/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import 'reflect-metadata';
import { Vertices } from '../vertices';

export function matchingShowSelected(
    target: any,
    propertyName: string,
    descriptor: TypedPropertyDescriptor<(self: Vertices) => boolean>
) {
    const method = descriptor.value!;

    descriptor.value = function () {
        const options: [Vertices] = arguments as unknown as [Vertices];
        const { current_object } = options[0];
        if (current_object) {
            options[0].showSelectedSteps = current_object.showSelectedSteps;
        }
        return method.apply(this, options);
    };
}

export function matchingShowStep(
    target: any,
    propertyName: string,
    descriptor: TypedPropertyDescriptor<(self: Vertices) => boolean>
) {
    const method = descriptor.value!;

    descriptor.value = function () {
        // const matchMetadataKey = Reflect.getMetadataKeys(target);
        // const requiredParameters: number[] = Reflect.getOwnMetadata(
        //     matchMetadataKey,
        //     target,
        //     propertyName
        // );
        // if (requiredParameters) {
        //     for (const parameterIndex of requiredParameters) {
        //         if (
        //             parameterIndex === arguments.length ||
        //             arguments[parameterIndex] === undefined
        //         ) {
        //             throw new Error('Missing required argument.');
        //         }
        //     }
        // }
        const options: [Vertices] = arguments as unknown as [Vertices];
        const { current_object } = options[0];
        if (current_object) {
            options[0].showStep = current_object.showStep;
        }
        return method.apply(this, options);
    };
}
